const autoNgTemplateLoaderTemplate1 = require('./customer-profile.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.customerProfile', [])
        .component('customerProfile', {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'CustomerProfileController',
            controllerAs: 'vm'
        })
        .config(customerProfileConfig);

    customerProfileConfig.$inject = ['$routeProvider'];

    function customerProfileConfig($routeProvider) {
        $routeProvider
            .when('/customer-profile/:id', {
                disableCache: true,
                reloadOnSearch: false,
                template: '<customer-profile></customer-profile>',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Customer Profile', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
                    ]
                }
            })
    }
})();
